import { Button, Input, QRCode, Space } from "../ui";
import { FormDrawer } from "../components/FormDrawer";
import type { MerchantPaymentLink } from "./merchantPaymentContracts";
import { useFeedback } from "../feedback/useFeedback";
export function MerchantPaymentLinkDrawer({ link, onClose, tr }: { link: MerchantPaymentLink | null; onClose: () => void; tr: (key: string) => string }) {
  const feedback = useFeedback();
  return <FormDrawer mode="view" dirty={false} open={link !== null} title={tr("merchantPayments.link")} onCancel={onClose}  >
    {link && <Space direction="vertical"><Input value={link.url} readOnly /><Space wrap>
      <Button onClick={() => { return navigator.clipboard.writeText(link.url).then(() => { void feedback.success(tr("merchantPayments.copied")); },
        () => { void feedback.error(tr("merchantPayments.copyFailed")); }); }}>{tr("merchantPayments.copy")}</Button>
      <Button href={link.url} target="_blank" rel="noopener noreferrer">{tr("merchantPayments.open")}</Button>
    </Space><QRCode value={link.url} /></Space>}
  </FormDrawer>;
}
